import { ButtonMui } from 'src/components/ButtonMui'
import { SelectMui } from 'src/components/SelectMui/SelectMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.4rem 0 0.4rem 0;
  max-width: 100%;
  gap: 2rem;
`

export const ErrorSummary = styled.p`
  color: red;
  font-weight: bold;
  font-size: 12px;
`

export const CustomButton = styled(ButtonMui)`
  width: 12rem;
  height: 2.5rem !important;
  margin: 0 !important;
`

export const CustomInputText = styled(TextFieldMui)`
  height: 2.5rem !important;
  margin: 0 !important;
`

export const CustomSelect = styled(SelectMui)`
  height: 2.5rem !important;
  width: 20rem;
  margin: 0 !important;
`
